import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledNav = styled.nav`
  position: fixed;
  background: ${theme.token.var('colors.white')};
  z-index: ${theme.token.var('zIndex.sticky')};
  width: 100vw;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;

  @media (min-width: 1400px) {
    padding: 0 calc((100% - 1320px) / 2);
  }
`
